import type { Tier } from "@/config/subscriptions"

// Which parts of the product are open, while LawLibrary.AI is still pre-launch.
//
// Separate from the access gate in lib/preview-gate.ts, and deliberately so. The gate decides
// who gets THROUGH the door (a shared access code, checked at the edge). This file decides what
// we are willing to OFFER on the far side of it, and it is read by client components, which
// cannot see a server-only env var.
//
// Both have to agree, because they fail in opposite directions: a gate with no flag shows a
// visitor a "Subscribe" button that walks them into an access-code form, and a flag with no gate
// hides the button while leaving /pricing reachable by URL. Neither alone is the state we want.

/**
 * Whether anyone can buy a subscription yet.
 *
 * `false` while /pricing is behind the access gate. Every subscribe CTA reads this rather than
 * being deleted, so opening sales is this one line rather than an archaeology exercise — see
 * the call sites in components/layout/AppHeader.tsx and components/marketing/LandingPage.tsx.
 */
export const SUBSCRIPTIONS_OPEN = false

/**
 * The `users.role` a new account is given while sales are closed, and the tier it counts as.
 *
 * Beta testers sign up without a plan — /sign-up skips the pricing page while SUBSCRIPTIONS_OPEN
 * is false — so they have no subscription for the tier logic to read. The role stands in for
 * one: lib/access resolves it to BETA_TIER, the same way it lets `admin` past every check. It is
 * per account, so one tester's access can be withdrawn by changing their row's role.
 *
 * Accounts keep the role after sales open. Moving them onto a plan is a decision for then.
 */
export const BETA_ROLE = 'beta'
export const BETA_TIER: Tier = 'pro'
